import type { Registration } from "../types";

/**
 * Extracts a displayable name from a registration object.
 * Checks for displayName, memberName, and falls back to joining lastName and firstName.
 * @param reg The registration object
 * @returns A formatted name string or "ー" as default
 */
export const getRegistrationDisplayName = (reg?: Registration): string => {
	if (!reg) return "ー";
	return (
		reg.liveMemberName ||
		reg.displayName ||
		reg.memberName ||
		`${reg.lastName || ""} ${reg.firstName || ""}`.trim() ||
		"ー"
	);
};
